import axios from 'axios'
import { camelizeKeys } from 'humps'
import config from '../utils/config'
//const PROFILE_ENDPOINT = config.api[process.env.NODE_ENV].profile
const PROFILE_ENDPOINT = config.api[process.env.NODE_ENV].hc360
// const HC_360_ENDPOINT = config.api[process.env.NODE_ENV].hc360

/**
|--------------------------------------------------
| [POST] Login
| @param {string} user
| @param {string} password
|--------------------------------------------------
*/
const defaultLoginParams = {
  user: '',
  password: ''
}

export const login = (params = defaultLoginParams) =>
  axios
    .post(`${PROFILE_ENDPOINT}/1.0/login`, params)
    .then(response => camelizeKeys(response.data))

/**
|--------------------------------------------------
| Forgot Password
|--------------------------------------------------
*/
export const recoverPassword = email =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('OK')
    }, 5000)
  })

/**
|--------------------------------------------------
| [GET] List Profile
|--------------------------------------------------
*/
const defaultProfileListParams = {
  name: '',
  page: 1,
  limit: 100,
  orderBy: 'name',
  email: '',
  company: ''
}
export const getListProfile = (params = defaultProfileListParams) =>
  axios
    .get(`${PROFILE_ENDPOINT}/profile/list`, {
      params: { ...params }
    })
    .then(response => camelizeKeys(response.data))



// WEBPACK FOOTER //
// ./src/api/profile.js